export default function getApiEndpoint() {
  if (window.location.href.includes('http://10.10.4.4')) {
    return 'http://10.10.4.4/api/';
  }
  return import.meta.env.VITE_APP_API_ENDPOINT;
}
